import vue from 'vue'

vue.mixin({
  methods: {
    // 相当于定义全局方法
    goto: function (state) {
      this.$router.push(state)
    },
    goback: function () {
      this.$router.go(-1)
    },
    Alert: function (options, cb) {
      let title = '温馨提示'
      let content = ''
      if (typeof options === 'object') {
        title = options.title || '温馨提示'
        content = options.content
      } else if (typeof options === 'string') {
        content = options
      }
      this.$alert(content, title, {
        confirmButtonText: '确定',
        callback: action => {
          if (cb && typeof cb === 'function') {
            cb()
          }
        }
      })
    },
    //富文本内容截取
    removeTAG(str) {
      return str.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, ' ').slice(0, 50) + '......'
    },
    //货物品名转化
    goodsFilter(goodsName) {
      if (goodsName == '0') {return '动力煤';}
      if (goodsName == '1') {return '炼焦煤';}
      if (goodsName == '2') {return '无烟煤';}
      if (goodsName == '3') {return '喷吹煤';}
      if (goodsName == '4') {return '块煤';}
      if (goodsName == '5') {return '兰炭';}
      if (goodsName == '6') {return '其它';}
    },
    //价格类型转化
    priceTypeFilter(priceType){
      if (priceType == '0') {return '车板价';}
      if (priceType == '1') {return '船板价';}
      if (priceType == '2') {return '到岸价';}
      if (priceType == '3') {return '到库价';}
      if (priceType == '4') {return '坑口价';}
      if (priceType == '5') {return '库提价';}
      if (priceType == '6') {return '平仓价';}
      if (priceType == '7') {return '一票价';}
    },
    getNormDate: function () {//获取当前时间
      let showDate = new Date();
      let seperator = '-';
      let year = showDate.getFullYear();
      let month = showDate.getMonth() + 1;
      let strDate = showDate.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      let currentdate = year + seperator + month + seperator + strDate;
      return currentdate;
    },
    getCurrentMonthFirst: function () {//获取当前月的下个月的第一天
      let date = new Date();
      date.setDate(1);
      if(date.getMonth() == 11 ) {
        date.setMonth(1)
        date.setFullYear(date.getFullYear()+1)
      }else{
        date.setMonth(date.getMonth() + 1+1)
      }
      let y = date.getFullYear(),
        m = (date.getMonth()>10||date.getMonth())==10?date.getMonth():'0'+date.getMonth(),
        d = (date.getDate()>10||date.getDate()==10)?date.getDate():'0'+date.getDate();

      return y + '-' + m + '-' + d
    },
    getCurrentMonthLast:function(){//获取当前月的下个月的最后一天
      let date = new Date()
      if(date.getMonth() == 11 ) {
        date.setMonth(1)
        date.setFullYear(date.getFullYear()+1)
      }else{
        date.setMonth(date.getMonth() + 1+1)
      }
      let y = date.getFullYear(),
        m = (date.getMonth()>10||date.getMonth()==10)?date.getMonth():'0'+date.getMonth(),
        tempDate =  new Date(y, m, 0),
      d = tempDate.getDate();

      return y + '-' + m + '-' + d
    },
    //number转换
    pointNumber:function(value){
      let v = value+'';
        if(v!=''&&v.indexOf('.')<0){
          return v+'.00'
        }else if(v!=''&&v.indexOf('.')>0&&v.split('.')[1].length=='1'){
          return v+'0'
        }else if(v!=''&&v.indexOf('.')>0&&v.split('.')[1].length=='2'){
          return v
        }
    },
    //判断时间是否过期
    judgeTime:function (time){
      let strtime = time.replace("/-/g", "/");//时间转换
    //时间
      let date1=new Date(strtime);
    //现在时间
      let date2=new Date();
    //判断时间是否过期
      return date1<=date2?true:false;
    },
    //汉英始发站模糊查询
    departureStations: function (station, callback) {
      this.$axios.post("RailwayStaNameQryList.do", {"stationsName": station,"stationsSpell": station}).then((response) => {
        if (response) {
          callback(response.RespMap.list.list)
        }
      }).catch((error) => {})
    },
    departureEntname: function (entname, callback) {
      this.$axios.post("EnterpriseInfoQryListForLogin.do", {"entName": entname}).then((response) => {
        if (response) {
          callback(response.RespMap.list.list)
        }
      }).catch((error) => {

      })
    },
    specialFliter: function(data, key, tips) {
      //将数组处理成字符串 dayDemandId
      const params = [];
      data.forEach(function (v, i) {
        params.push(v[key])
      })
      return params.join(tips);
    },
    provinceFilter: function (input) {
      if (input !== undefined && input !== null) {
        switch (input) {
          case '110000':
            input = '北京市'
            break
          case '120000':
            input = '天津市'
            break
          case '130000':
            input = '河北省'
            break
          case '140000':
            input = '山西省'
            break
          case '150000':
            input = '内蒙古自治区'
            break
          case '210000':
            input = '辽宁省'
            break
          case '220000':
            input = '吉林省'
            break
          case '230000':
            input = '黑龙江省'
            break
          case '310000':
            input = '上海市'
            break
          case '320000':
            input = '江苏省'
            break
          case '330000':
            input = '浙江省'
            break
          case '340000':
            input = '安徽省'
            break
          case '350000':
            input = '福建省'
            break
          case '360000':
            input = '江西省'
            break
          case '370000':
            input = '山东省'
            break
          case '410000':
            input = '河南省'
            break
          case '420000':
            input = '湖北省'
            break
          case '430000':
            input = '湖南省'
            break
          case '440000':
            input = '广东省'
            break
          case '450000':
            input = '广西壮族自治区'
            break
          case '460000':
            input = '海南省'
            break
          case '500000':
            input = '重庆市'
            break
          case '510000':
            input = '四川省'
            break
          case '520000':
            input = '贵州省'
            break
          case '530000':
            input = '云南省'
            break
          case '540000':
            input = '西藏自治区'
            break
          case '610000':
            input = '陕西省'
            break
          case '620000':
            input = '甘肃省'
            break
          case '630000':
            input = '青海省	'
            break
          case '640000':
            input = '宁夏回族自治区'
            break
          case '650000':
            input = '新疆维吾尔自治区'
            break
          case '710000':
            input = '台湾省	'
            break
          case '810000':
            input = '香港特别行政区'
            break

        }
      }
      return input;
    }
  },
  computed: {
    // 全局计算属性
  }
})
